export const calcTimeCountDown = ({ currentMin, currentSec }) => {
    let min = currentMin;
    let sec = currentSec;
    if (sec >= 0 && min >= 0) {
        sec = sec - 1;
        if (sec < 0) {
            min = min - 1;
        }
    }

    if (min < 0 && sec < 0) {
        min = 0;
        sec = 0;
    }

    if (sec < 0 && min >= 0) {
        sec = 59;
    }

    return { min, sec };
};
